import { createSignal } from "solid-js";
import { getRequestEvent, isServer } from "solid-js/web";

// 移动端判断
const mobilePatterns =
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|HarmonyOS|PlayBook|Opera Mini|Opera Mobi)/i;
// Create a reactive signal for mobile detection
const [isMobileState, setIsMobileState] = createSignal(false);

export { setIsMobileState };
// Function to check if device is mobile based on screen dimensions
export function checkMobile(userAgent: string) {
  return mobilePatterns.test(userAgent);
}

export function isMobile() {
  if (!isServer) {
    return isMobileState();
  } else {
    const event = getRequestEvent();
    return event?.locals.isMobile;
  }
}
